import { render, staticRenderFns } from "./ProjectsFeatureFlags.vue?vue&type=template&id=4a206bbc"
import script from "./ProjectsFeatureFlags.vue?vue&type=script&lang=js"
export * from "./ProjectsFeatureFlags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports